export const MAX_LEN = 4096
export const VAR_RE = /\{([a-zA-Z_][a-zA-Z0-9_]*)\}/g

// Тестовые значения для предпросмотра
export const TEST_VALUES = {
  client_name: 'Иван',
  manager_name: 'Анна',
  consultation_date: '15.06.2026',
  consultation_time: '14:00',
  address: 'ул. Абая, 10, офис 302',
}

// Безопасный проход по всем переменным в тексте.
// ВАЖНО: VAR_RE — глобальный regex с lastIndex, его нельзя шарить между
// одновременными вызовами. Поэтому каждый раз создаём локальную копию.
export const forEachVariable = (text, cb) => {
  const re = new RegExp(VAR_RE.source, 'g')
  let m
  while ((m = re.exec(text))) {
    cb(m[1], m[0], m.index)
  }
}

export const findUnknownVars = (text, availableVars = []) => {
  const unknown = new Set()
  forEachVariable(text, (name) => {
    if (!availableVars.includes(name)) unknown.add(name)
  })
  return [...unknown]
}

export const fillTemplate = (text) => {
  let out = ''
  let last = 0
  const re = new RegExp(VAR_RE.source, 'g')
  let m
  while ((m = re.exec(text))) {
    out += text.slice(last, m.index)
    out += TEST_VALUES[m[1]] ?? m[0]
    last = m.index + m[0].length
  }
  out += text.slice(last)
  return out
}
